import { ViewEncapsulation } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { SubscribtionService } from './../../../Services/subscribtion.service';
import { AddWriteAdTokenResponse, AdWritterInformationRequest } from './../../api/WickedApiClient';
import { MainService } from 'src/app/Services/service.service';
import { AdvertisementService } from './../../../Services/advertisement.service';
import { PremiumAdTokenPayment } from './../../../Components/premium-ad-token/premium-ad-token-paymen.component';
import { Router } from '@angular/router';

enum AddWritterView { Loading = 0, FormAndPayment = 1, SendInformationCompleted = 3 }

@Component({
  selector: 'ad-writter',
  templateUrl: './AdWritter.component.html',
  styleUrls: ['./AdWritter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MobileAdWritterComponent implements OnInit {

  public enableLetOurPros:boolean = false;

  gender = ["Male", "Female", "Transgender"];
  race = ["Arab", "Asian", "Black / Afro-American", "Hispanic", "Indian", "Mixed", "White / Caucasian"];

  @ViewChild('addTokenPayment', { static: false })  addTokenPayment: PremiumAdTokenPayment;

  dataForm: FormGroup;
  view: AddWritterView = AddWritterView.FormAndPayment;
  loading: boolean = false;
  canSubmit: boolean = false;
  blockSubmit: boolean = true;

  constructor(private formBuilder: FormBuilder, private subscriptionService: SubscribtionService, private mainService: MainService, private advertisementService: AdvertisementService, private router: Router) {
    
    this.enableLetOurPros = mainService.enableLetOurPros;
    if(!this.enableLetOurPros){
      this.router.navigate(['']);
    }
    
    this.dataForm = this.formBuilder.group({
      name: [''],
      age: [''],
      gender: [''],
      lookingFor: [''],
      height: [''],
      weight: [''],
      bodyType: [''],
      race: [''],
      idealMatch: [''],
      lookingForRelationship: [''],
      thingsInFreeTime: [''],
      aspectsOfLife: [''],
      dontLike: [''],
      passions: [''],
      occupation: [''],
      characteristics: [''],
      goalsAndDreams: [''],
      thankfullFor: [''],
      kids: [''],
      education: [''],
      workout: [''],
      travel: [''],
      healthyFood: [''],
      smoke: [''],
      alcohol: [''],
      email: [''],
      termsAndConditions: ['', [Validators.required]],
    });

    this.dataForm.controls["termsAndConditions"].valueChanges.subscribe(() => {
      this.blockSubmit = !this.dataForm.controls["termsAndConditions"].value;
    });
  }

  ngOnInit() {


  }

  onTokenAdded(response: AddWriteAdTokenResponse) {
    if (response.isError) {
      this.mainService.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
      this.loading = false;
    } else {

      let data: AdWritterInformationRequest = new AdWritterInformationRequest({
        name: this.dataForm.controls["name"].value,
        age: this.dataForm.controls["age"].value,
        gender: this.dataForm.controls["gender"].value,
        lookingFor: this.dataForm.controls["lookingFor"].value,
        height: this.dataForm.controls["height"].value,
        weight: this.dataForm.controls["weight"].value,
        bodyType: this.dataForm.controls["bodyType"].value,
        race: this.dataForm.controls["race"].value,
        idealMatch: this.dataForm.controls["idealMatch"].value,
        lookingForRelationship: this.dataForm.controls["lookingForRelationship"].value,
        thingsInFreeTime: this.dataForm.controls["thingsInFreeTime"].value,
        aspectsOfLife: this.dataForm.controls["aspectsOfLife"].value,
        dontLike: this.dataForm.controls["dontLike"].value,
        passions: this.dataForm.controls["passions"].value,
        occupation: this.dataForm.controls["occupation"].value,
        characteristics: this.dataForm.controls["characteristics"].value,
        goalsAndDreams: this.dataForm.controls["goalsAndDreams"].value,
        thankfullFor: this.dataForm.controls["thankfullFor"].value,
        kids: this.dataForm.controls["kids"].value,
        education: this.dataForm.controls["education"].value,
        workout: this.dataForm.controls["workout"].value,
        travel: this.dataForm.controls["travel"].value,
        healthyFood: this.dataForm.controls["healthyFood"].value,
        smoke: this.dataForm.controls["smoke"].value,
        alcohol: this.dataForm.controls["alcohol"].value,
        email: this.dataForm.controls["email"].value,
      });

      this.advertisementService.CreateAdWriteInformation(data).then(response => {
        if (response.isSend) {
          this.view = AddWritterView.SendInformationCompleted;
          this.canSubmit = false;
        }
        else {
          this.mainService.showError(response.error);
        }
        this.loading = false;
      }).catch( () => {
        console.log('Error with sending email');
        this.mainService.showError("Error with sending email, please contact with us.");
      });
    }

  }

  onSubmit() {
    if (!this.dataForm.valid || !this.addTokenPayment.form.valid) {
      return;
    }
     this.loading = true;
     this.addTokenPayment.onSubmit();
  }
}
